module.exports = __webpack_public_path__ + "img/main_down.725afec2.jpg";